// Outbound — dispatched by app code
export const WS_CONNECT    = 'WS_CONNECT';
export const WS_DISCONNECT = 'WS_DISCONNECT';
export const WS_SEND       = 'WS_SEND';
export const WS_FOCUS      = 'WS_FOCUS';

// Inbound — dispatched by the middleware into reducers / sagas
export const WS_CONNECTED    = 'WS_CONNECTED';
export const WS_DISCONNECTED = 'WS_DISCONNECTED';
export const WS_RECONNECTING = 'WS_RECONNECTING';
export const WS_ERROR        = 'WS_ERROR';
export const WS_MESSAGE      = 'WS_MESSAGE';

// Action creators
export const wsConnect    = ({ userId, orgId }) => ({ type: WS_CONNECT, payload: { userId, orgId } });
export const wsDisconnect = ()    => ({ type: WS_DISCONNECT });
export const wsSend       = (data) => ({ type: WS_SEND, payload: data });
// The claim the tab is showing; 0 means it is showing none.
export const wsFocus      = (workkardId) => ({ type: WS_FOCUS, payload: workkardId });
